export default [
  {
    title: 'Parte de horas',
    route: 'partesOperario',
    icon: 'ClockIcon',
  },
  {
    title: 'Política de registro horario',
    route: 'viewPolicy',
  },
]
